import React from 'react';
import { Title, Text } from '@gjensidige/builders-components';
// import '@gjensidige/builders-components/dist/style.css';
import { InformationModal } from '../InformationModal/InformationModal';
import { InforLink } from '../../../interfaces/EnquiryInterface';

interface InformationHeaderProps {
  title: string;
  informationText: string;
  infoLink?: InforLink;
  alignCenter: boolean;
  mainHeader?: boolean;
  headerAs?: any;
}
const InformationHeader: React.FC<InformationHeaderProps> = (
  props: InformationHeaderProps
) => {
  const returnClassName = () => {
    let className = '';
    if (props.mainHeader) {
      className += 'pb-lg-3';
    }
    if (props.alignCenter) {
      className += ' align-center';
    }
    return className;
  };
  return (
    <>
      <Title
        as={props.headerAs ? props.headerAs : 'h2'}
        size={`${props.mainHeader ? '3' : '4'}`}
        className={returnClassName()}
        id={`header-title-${props.title}`}
        aria-describedby={`${props.title}-more-info`}
      >
        {props.title}
      </Title>
      {props.informationText && (
        <Text size="body" className="pt-2">
          {props.informationText}
        </Text>
      )}
      {props.infoLink?.text && (
        <div className="pt-1">
          <InformationModal
            linkText={props.infoLink?.text}
            modalContent={props.infoLink?.description}
            leftAlignedLink
            buttonClassName="text-color"
            ariaDescribedBy={`${props.title}-more-info`}
            modalAriaLabel={props.infoLink?.modalAriaLabel || ''}
          />
        </div>
      )}
    </>
  );
};
export default InformationHeader;
